var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashUploads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7464 5.9858L20.2464 4.6733C18.0514 3.52205 16.9539 2.9458 15.7739 2.9458C14.5939 2.9458 13.4964 3.5208 11.3014 4.6733L10.9002 4.88455L22.0539 11.2583L27.0739 8.7458C26.2664 7.8308 24.9639 7.14705 22.7464 5.9833M27.9589 10.4008L22.9614 12.9008V16.6958C22.9614 16.9444 22.8627 17.1829 22.6868 17.3587C22.511 17.5345 22.2726 17.6333 22.0239 17.6333C21.7753 17.6333 21.5368 17.5345 21.361 17.3587C21.1852 17.1829 21.0864 16.9444 21.0864 16.6958V13.8383L16.7114 16.0258V27.8258C17.6089 27.6021 18.6302 27.0671 20.2464 26.2183L22.7464 24.9058C25.4352 23.4946 26.7802 22.7896 27.5277 21.5208C28.2739 20.2533 28.2739 18.6746 28.2739 15.5208V15.3746C28.2739 13.0083 28.2739 11.5283 27.9589 10.4008ZM14.8364 27.8258V16.0258L3.58893 10.4008C3.27393 11.5283 3.27393 13.0083 3.27393 15.3721V15.5183C3.27393 18.6746 3.27393 20.2533 4.02018 21.5208C4.76768 22.7896 6.11268 23.4958 8.80143 24.9071L11.3014 26.2183C12.9177 27.0671 13.9389 27.6021 14.8364 27.8258ZM4.47393 8.74705L15.7739 14.3971L20.0377 12.2658L8.93018 5.9183L8.80143 5.9858C6.58518 7.1483 5.28143 7.83205 4.47393 8.7483",
    fill: "#032A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashUploads);
export default __webpack_public_path__ + "static/media/dash_uploads.a49513d3915702d4707385179cca3907.svg";
export { ForwardRef as ReactComponent };